import { AnimatePresence, motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import { NavLink } from "react-router-dom";

export const SidebarMenuRecursive = ({ route, showAnimation = null, isOpen, setIsOpen, paddingMenu = null }) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setIsOpen(true);
    };

    useEffect(() => {
        if (!isOpen) {
            setIsMenuOpen(false);
        }
    }, [isOpen]);
    return (
        <>
            <div className="menu" style={{paddingLeft: paddingMenu}} onClick={toggleMenu}>
                <div className="menu_item" /* onClick={()=>navigate(route?.path)} style={{cursor: "pointer"}} */>
                    <div className="icon">{route.icon}</div>
                    <AnimatePresence>
                        {isOpen && (
                            <motion.div
                                // variants={showAnimation}
                                initial="hidden"
                                animate="show"
                                exit="hidden"
                                className="link_text"
                            >
                                {route.name.toLowerCase()}
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
                {isOpen && (
                    <motion.div
                        animate={
                            isMenuOpen
                                ? {
                                    rotate: -90,
                                }
                                : { rotate: 0 }
                        }
                    >
                        <FaAngleDown />
                    </motion.div>
                )}
            </div>{" "}
            <AnimatePresence>
                {isMenuOpen && (
                    <motion.div
                        // variants={menuAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="menu_container"
                    >
                        {route.subRoutes.map((subRoute, i) => (
                            <motion.div /* variants={menuItemAnimation} */ key={i} custom={i}>

                                {subRoute.subRoutes ? (
                                    <SidebarMenuRecursive
                                        route={subRoute}
                                        // showAnimation={showAnimation}
                                        isOpen={isOpen}
                                        setIsOpen={setIsOpen}
                                        paddingMenu={"20px"}
                                    />
                                ) : (
                                    <NavLink to={subRoute.path} className="link-submenu">
                                        {
                                            subRoute?.icon && (
                                                <div className="icon" style={{width: "40px"}}>{subRoute.icon}</div>
                                            )
                                        }
                                       
                                        <motion.div className="link_text">{subRoute.name.toLowerCase()}</motion.div>
                                    </NavLink>
                                )}
                            </motion.div>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};